import React from 'react';

type BoltIconAltProps = {
  width?: number;
  height?: number;
};

export const BoltIconAlt: React.FC<BoltIconAltProps> = ({ width = 20, height = 20 }) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 20 20' fill='none'>
    <g clipPath='url(#clip0_3892_3011)'>
      <path
        d='M14.4672 9.46996C14.54 9.35156 14.58 9.21589 14.5829 9.07692C14.5858 8.93795 14.5516 8.80071 14.4838 8.67937C14.416 8.55802 14.3171 8.45695 14.1972 8.38659C14.0773 8.31622 13.9409 8.2791 13.8019 8.27905H11.1458V1.40405L5.53276 10.5264C5.45987 10.6447 5.41989 10.7804 5.41695 10.9193C5.41401 11.0583 5.44822 11.1955 5.51604 11.3168C5.58386 11.4381 5.68283 11.5391 5.80273 11.6094C5.92264 11.6797 6.05913 11.7167 6.19811 11.7166H8.85415V18.5916L14.4672 9.46996Z'
        stroke='#5D666D'
        strokeWidth='1.5'
      />
    </g>
    <defs>
      <clipPath id='clip0_3892_3011'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export default BoltIconAlt;
